type TProps = {
  companyDashboardData: {
    companyGoal: number;
    invoiceTotalYtd: number;
    invoiceTotalYtdPrevious: number | null;
  };
};

const YtdDetails = ({ companyDashboardData }: TProps) => {
  const { invoiceTotalYtd, invoiceTotalYtdPrevious } = companyDashboardData;

  // Default to 0 if previous YTD is null
  const lastYearToDate = invoiceTotalYtdPrevious ?? 0;
  const yearToDate = invoiceTotalYtd;

  // Placeholder values for now (you can update with real data if available)
  const average = yearToDate / 365; // Assuming daily average
  const median = yearToDate / 365; // Can be adjusted if needed

  // Calculate percentage difference
  const difference = yearToDate - lastYearToDate;
  const percentageChange =
    lastYearToDate > 0 ? ((difference / lastYearToDate) * 100).toFixed(1) : "0.0";

  return (
    <div className="flex flex-col space-y-6">
      <div>
        <h2 className="text-lg font-bold text-green-400">
          Year to Date | {new Date().getFullYear()}
        </h2>
        <div className="text-2xl font-bold text-white">
          ${Math.round(yearToDate / 100).toLocaleString()}
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4 text-sm">
        <div className="flex justify-between">
          <span className="text-gray-400">Average</span>
          <span className="text-white font-bold">
            ${Math.round(average / 100).toLocaleString()}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-400">Median</span>
          <span className="text-white font-bold">
            ${Math.round(median / 100).toLocaleString()}
          </span>
        </div>
        <div className="flex justify-between">
          <span className="text-gray-400">Compare to Last Year</span>
          <span
            className={`font-bold ${difference > 0 ? "text-green-500" : "text-red-500"}`}
          >
            {difference > 0 ? "+" : ""}
            {percentageChange}%
          </span>
        </div>
      </div>
    </div>
  );
};

export default YtdDetails;
